"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textPresets = void 0;
const textPresets = function (theme, normalize) {
    return {
        normal: {
            // fontSize: normalize(theme.sizeP),
            // fontFamily: theme.textFont,
            // color: theme.textColor,
            fontSize: normalize(0.9 * theme.sizeP),
            fontFamily: theme.textFont,
            color: theme.currentPalette.c100,
        },
        big: {
            // fontSize: normalize(theme.sizeP),
            // fontFamily: theme.textFont,
            // color: theme.textColor,
            fontSize: normalize(1.2 * theme.sizeP),
            fontFamily: theme.textFont,
            color: theme.currentPalette.c100,
        },
        light: {
            fontSize: normalize(0.8 * theme.sizeP),
            fontFamily: theme.textFont,
            color: theme.currentPalette.c200,
        },
    };
};
exports.textPresets = textPresets;
//# sourceMappingURL=text.preset.js.map